codemirror_instances = {}

init_twig_mode = ->
  CodeMirror.defineMode 'htmltwig', (config, parserConfig) ->
    CodeMirror.overlayMode CodeMirror.getMode(config, parserConfig.backdrop or 'text/html'), CodeMirror.getMode(config, 'twig')

get_cm_instance = (id) ->
  unless codemirror_instances.hasOwnProperty id
    return null

  return codemirror_instances[id]

validate_js = (code, type) ->
  return true  unless code
  type = (if type then type else "javascript")
  JSHINT code,
    sub: true

  if JSHINT.errors.length
    errors = []
    $.each JSHINT.errors, (key, value) ->
      errors.push key + 1 + ") " + value.reason + " (line " + value.line + ")"  if value
      return

    title = "JavaScript Errors:\n"
    title = "JSON Errors:\n"  if type is "json"
    message = errors.join("\n")
    return confirm(title + message + "\nContinue save?")
  true

init_codemirror = ->
  init_twig_mode()
  $(document).find('textarea[data-codemirror]').each (i, checkbox) ->
    self = $ @
    width = self.outerWidth()
    height = self.outerHeight()
    language = self.attr 'data-codemirror'
    if language == 'twig' or language == 'htmltwig'
      language = {name: language, htmlMode: true}
    lint = self.attr 'data-lint'
    id = self.attr 'id'
    lint_err_container = self.parent().find('.error-lint-container')

    lint_err_container.empty()

    readOnly = false
    disabled = self.attr 'disabled'

    if disabled == 'disabled'
      readOnly = true

    init_opts = {
      mode: language,
      lineNumbers: true,
      lineWrapping: true,
      matchBrackets: true,
      showCursorWhenSelecting: true,
      foldGutter: true,
      readOnly: readOnly,
      onKeyEvent: ->
        instance.save()
        self.trigger 'change'
    }

    if lint
      $.extend init_opts, {
        gutters: ["CodeMirror-lint-markers", "CodeMirror-linenumbers", "CodeMirror-foldgutter"],
# lint: true,
        lint: {
          onUpdateLinting: (annotationsNotSorted, annotations, cm) ->
            if annotationsNotSorted.length == 0
              lint_err_container.empty()
              INTENT.utils.Forms.enable_submit_buttons()
            else
              lint_err_container.html(__('json.lint.error'))
              INTENT.utils.Forms.disable_submit_buttons()
        }
      }

    # init codemirror only on textarea with id
    if id and !codemirror_instances.hasOwnProperty id
      instance = CodeMirror.fromTextArea @, init_opts
      instance.setSize width, height
      codemirror_instances[id] = instance
      self.data('CodeMirrorInstance', instance)
      eventInitCodeMirrorEditor = new CustomEvent("event_init_mirror_editor", {
        detail: {id: id}
      })
      document.dispatchEvent(eventInitCodeMirrorEditor);
    else
      console.log 'codemirror with id ' + id + ' already inited'
